import React, { memo } from 'react'

type HeadingType = {
  Tag?: 'h1' | 'h2' | 'h3'
  title?: string
  size?:
    | 'text-xxs'
    | 'text-xs'
    | 'text-sm'
    | 'text-base'
    | 'text-lg'
    | 'text-xl'
    | 'text-2xl'
    | 'text-3xl'
    | 'text-4xl'
    | 'text-4xlh'
    | 'text-5xl'
    | 'text-6xl'
    | 'text-sm lg:text-base'
    | 'text-lg lg:text-2xl'
    | 'text-lg lg:text-3xl'
    | 'text-lg lg:text-4xl'
    | 'text-base lg:text-2xl'
  spsize?:
    | 'text-xxs lg:text-base'
    | 'text-xs lg:text-base'
    | 'text-sm lg:text-base'
    | 'text-base lg:text-lg'
    | 'text-base lg:text-xl'
    | 'text-base lg:text-2xl'
    | 'text-lg lg:text-2xl'
    | 'text-lg lg:text-3xl'
    | 'text-lg lg:text-4xl'
    | 'text-xl lg:text-3xl'
    | 'text-xl lg:text-4xl'
  textColor?:
    | 'primary'
    | 'darken'
    | 'textblack'
    | 'white'
    | 'secondary'
    | 'darkgray'
  textalign?: 'text-left' | 'text-center' | 'text-right'
  margin?: string
  id?: string
  children?: React.ReactNode | string
}

export const Heading: React.FC<HeadingType> = memo(
  ({
    children,
    Tag,
    size,
    spsize,
    textColor,
    textalign,
    margin,
    id,
    ...props
  }) => {
    const Component = Tag as keyof JSX.IntrinsicElements
    return (
      <Component
        className={`title ${textalign} text-${textColor} ${size} ${spsize} ${margin} font-bold`}
        id={id}
        dangerouslySetInnerHTML={{ __html: children as string }}
        {...props}
      />
    )
  }
)

Heading.displayName = 'Heading'
